import TimelineMax from 'TimelineMax';
import TweenMax from  'TweenMax';



const tab = {
    showAnimation: element => {
        const tl = new TimelineMax({
            delay: 0,
            repeat: 0,
            paused: true
        });
    
        tl.set(element, {
            transfromOrigin: '0% 70%'
        });
    
        tl.to(element, 1, {
            x: 0,
            y: 0,
            rotation: 0,
            scale: 1,
            ease: window.Power4.easeOut
        });
    
        return tl;
    },
    floatUp: element => {
        const play = () => {
            TweenMax.to(element, 1, {
                y: '-25%',
                ease: window.Back.easeOut.config(1)
            });
        }
    
        return {
            play
        }
    },
    floatDown: element => {
        const play = () => {
            TweenMax.to(element, 1, {
                y: '25%',
                ease: window.Back.easeOut.config(1)
            });
        }
    
        return {
            play
        }
    },
    floatBack: element => {
        const play = () => {
            TweenMax.to(element, 2, {
                y: '0%',
                ease: window.Back.easeOut.config(1)
            });
        }
    
        return {
            play
        }
    }
};

class TabAnimation {
    constructor(element) {
        this.show = tab.showAnimation(element);
        this.floatUp = tab.floatUp(element);
        this.floatDown = tab.floatDown(element);
        this.floatBack = tab.floatBack(element);
    }
}


const animations = {
    Tab: TabAnimation
};

export default animations;


// WEBPACK FOOTER //
// ./js/animations.js